export default __webpack_public_path__ + "static/media/Dagger of the Bloodhunter.b9015a78.jpg";